export default __webpack_public_path__ + "static/media/swapArrowHover.30fab687.png";